import {
  Collapse,
  DropdownItem,
  Nav,
  NavbarBrand,
  NavLink,
  NavLogoutLink,
  NavProfileLink,
  NavUserProfile,
} from '@sobrus-com/sobrus-design-system';
import { NotificationsContext } from 'Context';
import { AuthContext } from 'Context/AuthContext';
import { useAcl } from 'Hooks';
import React, { memo, useContext, useState } from 'react';
import { IoNotificationsOutline } from 'react-icons/io5';
import { Link, NavLink as RouterNavLink, useHistory } from 'react-router-dom';
import { NavPath } from 'Values/navPath';
import { Navbar } from '../Navbar/Navbar';
import { NavItem, NavItemMore, NavItemMoreSubMenu } from '../navItem';
import { NavItemMoreBtn } from '../NavItemMoreBtn';
import './Header.css';

const Header = memo(() => {
  const [showDropDown, setShowDropDown] = useState(false);
  const { user, loading, logout } = useContext(AuthContext);
  const { state } = useContext(NotificationsContext);
  const { can, canIndex } = useAcl();
  const { push } = useHistory();
  const handelReddirect = (e, does) => {
    if (does === undefined) {
      e.preventDefault();
    }
  };
  return (
    <Navbar>
      <NavbarBrand>
        <Link to="/home" className="Header_logo">
          <p>
            <strong>Sobrus</strong> WorkSpace
          </p>
        </Link>
      </NavbarBrand>
      <Collapse>
        <Nav>
          {can(['get_collaborater_notifications']) && (
            <div
              className={`HeaderItem  ${
                state?.totalnotifications > 0 ? 'nav__notifications' : 'nav__notifications__empty'
              }`}
            >
              <NavItem>
                <NavLink
                  tag={RouterNavLink}
                  to="/notifications"
                  onClick={(e) => {
                    handelReddirect(e, 'get_collaborater_notifications');
                  }}
                >
                  <div className="nav__notif">
                    <div>
                      <IoNotificationsOutline size={30} />
                      <span style={{ marginBottom: 0, fontWeight: 700 }}>{state?.totalnotifications}</span>
                    </div>
                  </div>
                </NavLink>
              </NavItem>
            </div>
          )}
          {NavPath?.map((headerItem) => (
            <>
              {can(headerItem?.does) && (
                <div
                  key={headerItem?.does}
                  className="HeaderItem"
                  onMouseOver={() => {
                    setShowDropDown(headerItem?.itemTitle);
                  }}
                  onFocus={() => setShowDropDown(headerItem?.itemTitle)}
                  onMouseOut={() => {
                    setShowDropDown(false);
                  }}
                  onBlur={() => setShowDropDown(false)}
                >
                  <NavItem>
                    <NavLink
                      tag={RouterNavLink}
                      to={
                        typeof headerItem.to === 'string' ? headerItem?.to : headerItem?.to[canIndex(headerItem?.does)]
                      }
                      onClick={(e) => {
                        setShowDropDown(false);
                        handelReddirect(e, headerItem?.does);
                      }}
                    >
                      {typeof headerItem.itemTitle === 'string'
                        ? headerItem?.itemTitle
                        : headerItem?.itemTitle[canIndex(headerItem?.does)]}
                      {showDropDown === headerItem?.itemTitle && (
                        <div className="subHeaderItem">
                          {headerItem?.dropDown?.map(
                            (subHeaderItem) =>
                              subHeaderItem?.does &&
                              can(subHeaderItem?.does) && (
                                <React.Fragment key={subHeaderItem?.to}>
                                  <NavLink
                                    tag={RouterNavLink}
                                    to={subHeaderItem?.to}
                                    onMouseEnter={() => setShowDropDown(headerItem?.itemTitle)}
                                    onMouseOut={() => setShowDropDown(false)}
                                  >
                                    {subHeaderItem?.itemTitle}
                                  </NavLink>
                                </React.Fragment>
                              )
                          )}
                        </div>
                      )}
                    </NavLink>
                  </NavItem>
                </div>
              )}
            </>
          ))}
          <NavItemMore>
            <NavItemMoreBtn title="Plus" />
            <NavItemMoreSubMenu />
          </NavItemMore>
        </Nav>

        <NavUserProfile fullName={!loading ? `${user?.lastName} ${user?.firstName}` : ''}>
          <DropdownItem>
            <NavProfileLink onClick={() => push('/profile')} />
          </DropdownItem>

          <DropdownItem className="last-dropdown-item">
            <NavLogoutLink onClick={logout} />
          </DropdownItem>
        </NavUserProfile>
      </Collapse>
    </Navbar>
  );
});

export default Header;
